module.exports = __webpack_public_path__ + "img/40.4522730e.jpg";